import React, { useState, useEffect } from "react";
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import image01 from '../image/image01.jpg';
import image02 from '../image/image02.jpg';
import image03 from '../image/image03.jpg';
import image04 from '../image/image04.jpg';

const heroImages = [image01, image02, image03, image04];

const HeroSection: React.FC = () => {
  const title = '民族文化生物学研究会';
  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    document.title = title;
  }, [title]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage(prev => (prev + 1) % heroImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="relative h-screen min-h-[500px] flex items-center justify-center overflow-hidden">
      {/* 背景スライダー */}
      {heroImages.map((img, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ${index === currentImage ? 'opacity-100' : 'opacity-0'}`}
        >
          <img src={img} alt="" className="w-full h-full object-cover" />
        </div>
      ))}
      {/* オーバーレイ */}
      <div className="absolute inset-0 bg-black/35" />
      {/* テキストコンテンツ */}
      <div className="relative z-10 text-center px-4 max-w-4xl mx-auto">
        <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 sm:mb-6 drop-shadow-lg">
          {title}
        </h1>
        <p className="text-sm sm:text-base md:text-lg text-white/90 mb-8 sm:mb-10 max-w-2xl mx-auto leading-relaxed px-2 drop-shadow">
          各地域の文化(衣食住・習慣・歴史)と生物資源(動植物・菌類など)の多様な関係を研究し、地域文化の多様性を明らかにしながら生物資源の新たな活用と共生のあり方を探ります。
        </p>
        <div className="flex flex-col gap-3 sm:flex-row sm:gap-4 justify-center px-4">
          <a
            href="#join"
            className="inline-block bg-[#4a7c59] text-white px-6 py-3 sm:px-8 sm:py-4 text-sm sm:text-base rounded-full font-semibold shadow-lg hover:bg-[#3d6a4a] transition"
            onClick={e => { e.preventDefault(); document.getElementById('join')?.scrollIntoView({ behavior: 'smooth' }); }}
          >
            入会する
          </a>
          <a
            href="#articles"
            className="inline-block border-2 border-white/80 text-white px-6 py-3 sm:px-8 sm:py-4 text-sm sm:text-base rounded-full font-semibold hover:bg-white/10 transition"
            onClick={e => { e.preventDefault(); document.getElementById('articles')?.scrollIntoView({ behavior: 'smooth' }); }}
          >
            活動を見る
          </a>
        </div>
      </div>
      {/* スクロール矢印 */}
      <button
        onClick={() => document.getElementById('reports')?.scrollIntoView({ behavior: 'smooth' })}
        className="absolute bottom-8 right-4 sm:right-8 text-white/70 hover:text-white transition-colors animate-bounce-slow hidden sm:block"
        aria-label="下にスクロール"
      >
        <ChevronDownIcon className="w-8 h-8" />
      </button>
      {/* スライドインジケーター */}
      <div className="absolute bottom-6 sm:bottom-8 left-1/2 -translate-x-1/2 flex gap-2">
        {heroImages.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentImage(index)}
            className={`h-2 rounded-full transition-all duration-300 ${index === currentImage ? 'bg-white w-6' : 'bg-white/50 w-2'}`}
            aria-label={`スライド ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
};

export default HeroSection;
